/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect, useState } from "react";
import {
  AppBar,
  Box,
  CircularProgress,
  ImageList,
  ImageListItem,
  ImageListItemBar,
  Toolbar,
  Typography,
} from "@mui/material";
import { getDownloadURL, getStorage, list, listAll, ref } from "firebase/storage";

const PRIMARY_COLOR = "#17165A";
const SECONDARY_COLOR = "#FFD361";
const TERTIARY_COLOR = "#FFFFFF";

export const Mobile = () => {
  const [imageUrls, setImageUrls] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchImages = async () => {
      const storage = getStorage();

      const listRef = ref(storage, "gs://niran-fce3f.appspot.com/products");
      const imageFiles = await listAll(listRef);
      // const imageFiles = await list(listRef, { maxResults: 10 });

      const urls = await Promise.all(
        imageFiles.items.map((item) =>
          getDownloadURL(ref(storage, item.fullPath)),
        ),
      );
      setImageUrls(urls);
      console.log("imageUrls", urls);
      // setLoading(false);
    };

    fetchImages();
  }, []);

  return (
    <Box sx={{ flexGrow: 1, backgroundColor: (loading ? PRIMARY_COLOR : TERTIARY_COLOR)  }}>
      {/* App Bar */}
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: PRIMARY_COLOR,
          color: SECONDARY_COLOR,
        }}
      >
        <Toolbar sx={{ height: "64px" }}>
          <Typography
            variant="h4"
            sx={{
              flexGrow: 1,
              display: "flex",
              justifyContent: "center",
              fontFamily: "Tenor Sans",
            }}
          >
            NIRAN
          </Typography>
        </Toolbar>
      </AppBar>
      <Box sx={{ height: "64px" }} />

      {/* Body */}
      {loading && (
        <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
        >
          <CircularProgress sx={{ color: SECONDARY_COLOR }} />
        </Box>
      )}
      <ImageList sx={{ width: "100%", margin: 0 }} cols={1} gap={1}>
          {imageUrls.map((image, index) => (
            <ImageListItem key={index}>
              <img
                id={`image-${index}`}
                srcSet={`${image}?fit=crop&auto=format&dpr=2 2x`}
                src={`${image}?fit=crop&auto=format`}
                alt={image}
                loading="lazy"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
                onLoad={() => { setLoading(false) }}
              />
              <ImageListItemBar
                sx={{
                  background:
                    "linear-gradient(to top, rgba(0,0,0,0.9) 0%, " +
                    "rgba(0,0,0,0.3) 60%, rgba(0,0,0,0) 100%)",
                }}
                title={<Box style={{ fontSize: "1.25rem", margin: "2rem 0.5rem 0.5rem", fontFamily: "Tenor Sans", opacity: 0.8, fontWeight: "bold" }}>{"Burmese Ruby"}</Box>}
                subtitle={<Box style={{ fontSize: "1.5rem", margin: "auto 0.5rem 0.5rem", fontFamily: "Tenor Sans", opacity: 0.8 }}>{`Size 8 | $700 ${index}`}</Box>}
                position="bottom"
              />
            </ImageListItem>
          ))}
        </ImageList>
      
    </Box>
  );
};
